import { LeftMenuItems, RouteEnum } from "../../../../models/enums";
import { LeftSideBarItem } from "../../UnifiedLayout";

export const CustomerOperatorForemanReadOnlyItems: LeftSideBarItem[] = [
  {
    name: LeftMenuItems.TELEMETRY,
    path: RouteEnum.Empty,
    nonClickable: true,
    nestedItems: [
      {
        name: LeftMenuItems.TANK_LEVEL,
        path: RouteEnum.SensoryTelemetryTlm,
      },
      {
        name: LeftMenuItems.GATE_GUARD,
        path: RouteEnum.SensoryTelemetryAgg,
      },
    ],
  },
  {
    name: LeftMenuItems.CONTROL_ROOM_BETA,
    path: RouteEnum.SensoryControlRoom,
  },
  {
    name: LeftMenuItems.RECENT_ACTIVITIES,
    path: RouteEnum.SensoryRecentActivities,
  },

  {
    name: LeftMenuItems.LIVE_VIEW,
    path: RouteEnum.SensoryLiveView,
  },
  {
    name: LeftMenuItems.DEPLOYMENT_HEALTH,
    path: RouteEnum.SensoryDeploymentHealth,
  },
  {
    name: LeftMenuItems.STATISTICS,
    path: RouteEnum.SensoryStatistics,
    showDivider: true,
  },
];
